import React from 'react';
import { FileDocumentType } from '@nkr/enums/index';
import { IRecipientProfilePostTransplantData } from '@nkr/models/index';
import { Col, Panel, Row } from 'react-bootstrap';
import { FinancialAgreement } from '@nkr/views/match/documents/financial-agreement';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, FileActionCreators, DonorActionCreators, IAmbraDirectToViewerResponse } from '@nkr/store/index';
import { downloadFile } from '@nkr/services/download-file';

interface IProps {
    recipientId: number,
    centerId: number,
    data: IRecipientProfilePostTransplantData,
    onViewFile: (docType: FileDocumentType) => void,
    onGetFinancialInfo: (donorId: number) => void,
}

interface IStateProps { }

interface IDispatchProps {
    downloadFormsAndChecklist: (donorId: number, recipientId: number) => Promise<any>,
    getAmbraLink: (donorId: number) => Promise<IAmbraDirectToViewerResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const DonorDocuments = (props: TProps) => {
    const handleCtView = (donorId: number) => {
        props.getAmbraLink(donorId).then(response => {
            window.open(response.data.results, '_blank');
        });
    };

    const handleFormsChecklist = (donorId: number, recipientId: number) => {
        props.downloadFormsAndChecklist(donorId, recipientId)
                    .then((response: any) => {
                        downloadFile(response.data, `form-and-checklists-${recipientId}-${donorId}.pdf`, 'application/pdf');
                    });
    };

    const handleEpletMismatchView = (donorId: number, recipientId: number) => {
        window.open(`/center/${props.centerId}/recipient/${recipientId}/eplet-mm/${donorId}`, '_blank');
    };

    return (
        <Panel>
            <Panel.Heading>Post Transplant Donor Documents</Panel.Heading>
            <Panel.Body>
                {props.data.transplantedDonor && (
                    <Row>
                        {props.data.transplantedDonor.medChartUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorMedChart)}>NKR Donor Chart</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.ctReportUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorCTReport)}>Donor CT Report</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.hasCtScanOnline && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => handleCtView(props.data.transplantedDonor.id)}>View Donor CT Study</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.rawTypingUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorRawTyping)}>Donor Raw Typing Results</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.centerAboUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorCTRABO)}>Center Abo Verification Report</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.vrlAboUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorVRLABO)}>VRL Abo Verification Report</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.vrlAboMolecularUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorVRLABOMol)}>VRL A2 Molecular Verification Report</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.vrlAboA2ConfirmatoryUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorVRLABOMol)}>VRL A2 2nd Draw Confirmatory Report</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.vrlHlaUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorRawTyping)}>VRL HLA Raw Intermediate Typing HLA Report</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.serologyUploadPath && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorSerology)}>View Serology</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.isExportable && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => handleEpletMismatchView(props.data.transplantedDonor.id, props.recipientId)}>Eplet Mismatch Risk</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.covidTestUpload && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => props.onViewFile(FileDocumentType.DonorVRLABOMol)}>COVID PCR Test Results</a>
                            </Col>
                        )}

                        {props.data.transplantedDonor.aboASubType && (
                            <Col xs={12} lg={3}>
                                <FinancialAgreement className='btn-link' centerId={props.centerId} donorId={props.data.transplantedDonor.id} recipientId={props.recipientId}><span className='text'>Financial Info</span></FinancialAgreement>
                            </Col>
                        )}

                        {props.data.transplantedDonor.id && props.recipientId && (
                            <Col xs={12} lg={3}>
                                <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => handleFormsChecklist(props.data.transplantedDonor.id, props.recipientId)}>Forms & Checklist</a>
                            </Col>
                        )}
                    </Row>
                )}
            </Panel.Body>
        </Panel>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {       
        downloadFormsAndChecklist: (donorId: number, recipientId: number) => {
            return dispatch(FileActionCreators.getFormsAndChecklists(donorId, recipientId));
        },
        getAmbraLink: (donorId: number) => {
            return dispatch(DonorActionCreators.getAmbraLink(donorId));
        },
    };
}


export default connect<{}, IDispatchProps, IProps>(   
    mapStateToProps,
    mapDispatchToProps)(DonorDocuments);